import React from "react";
import { MarketingLayout } from "@byscott-io/corebyscott";

export default function AboutPage() {
  return (
    <MarketingLayout>
      <div className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
            About MetricsByScott
          </h1>

          <div className="prose dark:prose-invert max-w-none">
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
              MetricsByScott is analytics and a data warehouse in one place: it records what
              happens in an app &mdash; events, page views, feature usage &mdash; and it tracks
              values that change over time, so a number like monthly revenue or active users has
              a history rather than only a current value.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Why We Built This
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Hosted analytics answers questions about traffic but will not tell you what a
              particular customer did, and it keeps your data on someone else&rsquo;s terms. The
              figures a business actually runs on &mdash; revenue, retention, how many people use
              the feature you just shipped &mdash; end up spread across tools that cannot be
              queried together. MetricsByScott keeps both kinds of measurement in one store that
              you own.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Built To Be Queried
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Tracking is a few API calls from your server or your front end. What you get back is
              not a fixed dashboard: metrics are queryable over any period, with temporal
              aggregation built in, and AI agents can query them directly rather than waiting for
              someone to export a report.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Part of IdeasByScott
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              MetricsByScott is part of the IdeasByScott suite of practical tools. We build
              software that solves real problems for real people, without unnecessary complexity.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Privacy First
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Your data stays yours. There is no third-party tracking and nothing is sold on. The
              measurements an app sends are stored for that app and queried by that app, which is
              the whole reason to run your own analytics rather than rent someone else&rsquo;s.
            </p>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
